<template>
  <div>
    <v-dialog v-model="deleteAssetDialog" max-width="500">
      <v-form ref="form">
        <v-card>
          <v-card-title class="headline red--text"
            >Give reason for deleting item</v-card-title
          >
          <v-divider></v-divider>
          <br />

          <v-card-text>
            <v-textarea
              v-model="deleteReason"
              :rules="[rules.required]"
              outlined
              label="Reason"
            ></v-textarea>
          </v-card-text>

          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn color="blue darken-1" text @click="deleteAssetDialog = false"
              >Cancel</v-btn
            >

            <v-btn color="red darken-1" text @click="onDeleteAsset()"
              >Delete</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-container>
      <v-card-text style="position: relative; bottom: -350px">
        <v-fab-transition>
          <v-btn
            color="#6fac46"
            fab
            large
            dark
            absolute
            bottom
            class="v-btn--back"
            @click="navigateFrontPage"
          >
            <v-icon>keyboard_arrow_left</v-icon>
          </v-btn>
        </v-fab-transition>
      </v-card-text>

      <v-snackbar
        v-model="message.snackbar"
        :timeout="message.snackbarTimeout"
        top
      >
        {{ message.snackbarText }}
        <v-btn dark text @click="message.snackbar = false">Close</v-btn>
      </v-snackbar>
      <v-tabs fixed-tabs background-color="#363532" dark icons-and-text>
        <v-tab>
          Asset
          <v-icon>web</v-icon>
        </v-tab>
        <v-tab>
          Maintenance
          <v-icon>settings_overscan</v-icon>
        </v-tab>
        <v-tab>
          History
          <v-icon>history</v-icon>
        </v-tab>
        <v-tab-item>
          <v-card class="mx-auto" flat max-width="750">
            <v-list>
              <p class="pt-5 body-2 grey--text">{{ asset.product }}</p>
              <v-form
                ref="form"
                v-if="asset.product === 'Health Assessment'"
                lazy-validation
              >
                <v-text-field
                  v-model="assetForm.description"
                  :rules="[rules.required]"
                  label="Description"
                  required
                ></v-text-field>
                <v-text-field
                  v-model="assetForm.reference"
                  :rules="[rules.required]"
                  label="HP reference"
                  required
                ></v-text-field>
                <v-text-field
                  v-model="assetForm.serial"
                  :rules="[rules.required]"
                  label="Serial number"
                  required
                ></v-text-field>
                <v-text-field
                  v-model="assetForm.model"
                  :rules="[rules.required]"
                  label="Model"
                  required
                ></v-text-field>
                <v-text-field
                  v-model="assetForm.cost"
                  :rules="[rules.required, rules.currency]"
                  label="Cost"
                  prefix="£"
                  @change="filterCurrency"
                  required
                ></v-text-field>
                <v-text-field
                  v-model="assetForm.supplierLink"
                  :rules="[rules.url]"
                  label="Supplier app link"
                  prefix="http://"
                  required
                ></v-text-field>
                <v-select
                  v-model="assetForm.maintenance"
                  :items="maintenance"
                  label="Maintenance frequency"
                ></v-select>
              </v-form>

              <v-form
                ref="form"
                v-if="asset.product === 'Health Promotion'"
                lazy-validation
              >
                <v-text-field
                  v-model="assetForm.description"
                  :rules="[rules.required]"
                  label="Description"
                  required
                ></v-text-field>
                <v-text-field
                  v-model="assetForm.reference"
                  :rules="[rules.required]"
                  label="HP Reference"
                  required
                ></v-text-field>
                <v-text-field
                  v-model="assetForm.serial"
                  :rules="[rules.required]"
                  label="Serial number"
                  required
                ></v-text-field>
                <v-text-field
                  v-model="assetForm.model"
                  :rules="[rules.required]"
                  label="Model"
                  required
                ></v-text-field>
                <v-text-field
                  v-model="assetForm.cost"
                  :rules="[rules.required, rules.currency]"
                  label="Cost"
                  prefix="£"
                  @change="filterCurrency"
                  required
                ></v-text-field>
                <v-text-field
                  v-model="assetForm.supplierLink"
                  :rules="[rules.url]"
                  label="Supplier app link"
                  prefix="http://"
                  required
                ></v-text-field>
                <v-select
                  v-model="assetForm.maintenance"
                  :items="maintenance"
                  label="Maintenance frequency"
                ></v-select>
              </v-form>

              <v-form ref="form" v-if="asset.product === 'IT'" lazy-validation>
                <v-text-field
                  v-model="assetForm.description"
                  :rules="[rules.required]"
                  label="Description"
                  required
                ></v-text-field>
                <v-text-field
                  v-model="assetForm.model"
                  :rules="[rules.required]"
                  label="Model"
                  required
                ></v-text-field>
                <v-select
                  v-model="assetForm.maintenance"
                  :items="maintenance"
                  label="Maintenance frequency"
                ></v-select>
                <v-text-field
                  v-model="assetForm.reference"
                  :rules="[rules.required]"
                  label="HP Reference"
                  required
                ></v-text-field>
                <v-text-field
                  v-model="assetForm.serial"
                  :rules="[rules.required]"
                  label="Serial number"
                  required
                ></v-text-field>

                <v-text-field
                  v-model="assetForm.cost"
                  :rules="[rules.required, rules.currency]"
                  label="Cost"
                  prefix="£"
                  @change="filterCurrency"
                  required
                ></v-text-field>
                <v-text-field
                  v-model="assetForm.password"
                  label="Password"
                  hint="Bitlocker code or anything else relevant"
                  :persistent-hint="true"
                ></v-text-field>
                <v-text-field
                  v-model="assetForm.supplierLink"
                  :rules="[rules.url]"
                  label="Supplier app link"
                  prefix="http://"
                  required
                ></v-text-field>
              </v-form>

              <v-form
                ref="form"
                v-if="asset.product === 'Office Furniture'"
                lazy-validation
              >
                <v-text-field
                  v-model="assetForm.description"
                  :rules="[rules.required]"
                  label="Description"
                  required
                ></v-text-field>
                <v-text-field
                  v-model="assetForm.model"
                  :rules="[rules.required]"
                  label="Model"
                  required
                ></v-text-field>
                <v-select
                  v-model="assetForm.maintenance"
                  :items="maintenance"
                  label="Maintenance frequency"
                ></v-select>
                <v-text-field
                  v-model="assetForm.reference"
                  :rules="[rules.required]"
                  label="HP Reference"
                  required
                ></v-text-field>
                <v-text-field
                  v-model="assetForm.serial"
                  :rules="[rules.required]"
                  label="Serial number"
                  required
                ></v-text-field>

                <v-text-field
                  v-model="assetForm.cost"
                  :rules="[rules.required, rules.currency]"
                  label="Cost"
                  prefix="£"
                  @change="filterCurrency"
                  required
                ></v-text-field>
                <v-text-field
                  v-model="assetForm.supplierLink"
                  :rules="[rules.url]"
                  label="Supplier app link"
                  prefix="http://"
                  required
                ></v-text-field>
              </v-form>
            </v-list>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn color="error" text @click="deleteAssetDialog = true"
                >Delete</v-btn
              >
              <v-spacer></v-spacer>
              <v-btn color="info" text @click="onCopyAsset">Duplicate</v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="onCreateAsset">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card class="mx-auto px-3" flat>
            <p class="pt-5 body-2 grey--text">Calibrate {{ asset.product }}</p>
            <v-data-table
              :headers="calibrationHeader"
              :items="calibration"
              class="elevation-1"
            >
              <template v-slot:item.type="{ item }">
                <v-chip
                  v-if="item.result === 'Pass' && item.calibrate"
                  color="green"
                  dark
                  >Calibrated</v-chip
                >
                <v-chip
                  v-if="item.result === 'Fail' && item.calibrate"
                  color="red"
                  dark
                  >Calibrated</v-chip
                >
                <v-chip color="success" v-if="item.service" dark
                  >Serviced</v-chip
                >
                <v-chip color="warning" v-if="item.other" dark>Other</v-chip>
              </template>

              <template v-slot:item.gravitar="{ item }">
                <v-avatar
                  size="40"
                  v-if="getAvatarUrl(item.maintainedByEmail)"
                  class="ml-2"
                >
                  <img :src="getAvatarUrl(item.maintainedByEmail)" />
                </v-avatar>
                <v-icon v-else size="48" color="grey lighten-1" class="ml-1"
                  >mdi-account-circle</v-icon
                >
              </template>

              <template v-slot:item.date="{ item }">{{
                item.date | moment("dddd, Do MMM YYYY")
              }}</template>

              <template v-slot:item.result="{ item }">
                <span style="color: green" v-if="item.result === 'Pass'">{{
                  item.result
                }}</span>
                <span style="color: red" v-else-if="item.result === 'Fail'">{{
                  item.result
                }}</span>
                <span v-else>{{ item.result }}</span>
              </template>
            </v-data-table>

            <v-card-text style="height: 100px; position: relative">
              <v-fab-transition>
                <v-btn
                  color="#ff0000"
                  dark
                  absolute
                  top
                  right
                  fab
                  @click="maintenanceDialog = !maintenanceDialog"
                >
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </v-fab-transition>
            </v-card-text>

            <v-dialog v-model="maintenanceDialog" max-width="500px">
              <v-card>
                <v-card-title class="grey--text">Maintenance</v-card-title>
                <v-divider></v-divider>
                <br />
                <v-card-text>
                  <v-menu
                    ref="menu"
                    :close-on-content-click="false"
                    :return-value.sync="maintenanceForm.date"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="maintenanceForm.date"
                        :rules="[rules.required]"
                        label="Calibration date"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="maintenanceForm.date"
                      no-title
                      scrollable
                    >
                      <div class="flex-grow-1"></div>
                      <v-btn text color="primary" @click="menu = false"
                        >Cancel</v-btn
                      >
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu.save(maintenanceForm.date)"
                        >OK</v-btn
                      >
                    </v-date-picker>
                  </v-menu>

                  <v-select
                    v-model="maintenanceForm.staff"
                    :items="staff"
                    :rules="[rules.required]"
                    label="Staff member"
                  ></v-select>

                  <v-radio-group v-model="maintenanceForm.type" row>
                    <v-radio label="Calibrate" value="calibrate"></v-radio>
                    <v-radio label="Service" value="service"></v-radio>
                    <v-radio label="Other" value="other"></v-radio>
                  </v-radio-group>

                  <v-textarea
                    v-if="maintenanceForm.type !== 'calibrate'"
                    v-model="maintenanceForm.result"
                    filled
                    name="input-7-1"
                    label="Result"
                  ></v-textarea>

                  <v-radio-group
                    row
                    v-if="maintenanceForm.type === 'calibrate'"
                    v-model="maintenanceForm.result"
                  >
                    <v-radio label="Pass" value="Pass"></v-radio>
                    <v-radio label="Fail" value="Fail"></v-radio>
                  </v-radio-group>

                  <v-textarea
                    v-if="maintenanceForm.type == 'calibrate'"
                    v-model="maintenanceForm.note"
                    filled
                    name="input-7-1"
                    label="Note"
                  ></v-textarea>
                </v-card-text>

                <v-card-actions>
                  <div class="flex-grow-1"></div>
                  <v-btn text color="primary" @click="onCreateMaintenanceTask"
                    >Submit</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card class="mx-auto px-3" flat>
            <p class="pt-5 body-2 grey--text">History</p>

            <v-data-table
              :headers="headers"
              :items="history"
              class="elevation-1"
            >
              <template v-slot:item.gravitar="{ item }">
                <!-- <v-avatar size="40" color="grey lighten-3" style="margin-left: 5px;">
                  <v-gravatar :email="item.createdByEmail" default-img="mp" :size="40" />
                </v-avatar>-->
                <v-avatar
                  size="40"
                  v-if="getAvatarUrl(item.createdByEmail)"
                  class="ml-2"
                >
                  <img :src="getAvatarUrl(item.createdByEmail)" />
                </v-avatar>
                <v-icon v-else size="48" color="grey lighten-1" class="ml-1"
                  >mdi-account-circle</v-icon
                >
              </template>

              <template v-slot:item.date="{ item }">{{
                item.date | moment("dddd, Do MMM YYYY")
              }}</template>
            </v-data-table>
          </v-card>
        </v-tab-item>
      </v-tabs>
    </v-container>
  </div>
</template>

<script>
import DefaultLayout from "../layouts/DefaultLayout";
import { API, graphqlOperation } from "aws-amplify";
import { Auth } from "aws-amplify";
import { hpUser } from "../classes/hpUser";
import _ from "lodash";

export default {
  components: {},
  created() {
    this.$emit(`update:layout`, DefaultLayout);
    this.getUsers();
    this.getAssets(this.$route.params.id);
  },
  data() {
    return {
      staff: [],
      asset: "",
      assets: ["Height Meter", "Tape Measure", "Bodystat", "Laptop"],
      maintenance: ["N/A", "Daily", "Weekly", "Monthly", "Yearly"],
      deleteAssetDialog: false,
      valid: true,
      serialRules: [v => !!v || "Serial number is required"],
      tapeMeasureRules: [v => !!v || "Tap Measure is required"],
      serial: "",
      cables: "",
      testingProng: "",
      screwdriver: "",
      bitLocker: "",
      password: "",
      deleteReason: "",
      date: new Date().toISOString().substr(0, 10),
      maintenanceDialog: false,
      rules: {
        required: (v) => !!v || "This field is required.",
        minimum: (v) => v.length >= 8 || "Minimum 8 characters",
        currency: (v) =>
          /^\$?(([1-9]\d{0,4}(,\d{3})*)|0)?\.\d{1,2}$/.test(v) ||
          "GBP format is required eg 10.00",
        url: function (v) {
          if (!!v) {
            // let regex = /^((ftp|http|https):\/\/)?www\.([A-z]+)\.([A-z]{2,})/
            const regex = /^((ftp|http|https):\/\/).([A-z]+)\.([A-z]{2,})/;
            if (!regex.test("https://" + v)) {
              return "Url not valid";
            }
          }
          return true;
        },
      },
      message: {
        snackbar: false,
        snackbarText: "",
        snackbarTimeout: 3000,
      },
      assetForm: {
        description: "",
        reference: "",
        serial: "",
        model: "",
        cost: "",
        password: "",
      },
      maintenanceForm: {
        date: new Date().toISOString().substr(0, 10),
        staff: "",
      },
      calibration: [],
      history: [],
      headers: [
        {
          align: "left",
          sortable: false,
          value: "gravitar",
        },
        {
          text: "By",
          value: "createdBy",
        },
        {
          text: "Date",
          align: "left",
          value: "date",
        },

        { text: "Notes", value: "history" },
      ],
      calibrationHeader: [
        {
          align: "left",
          sortable: false,
          value: "gravitar",
        },
        {
          align: "left",
          sortable: false,
          value: "type",
        },
        {
          text: "Date",
          align: "left",
          sortable: false,
          value: "date",
        },
        { text: "By", value: "maintainedBy" },
        { text: "Results", value: "result" },
        { text: "Note", value: "note" },
      ],
    };
  },
  methods: {
    async getUsers() {
      let that = this;
      that.hpUser = [];
      that.staff = [];

      let hpUserObj = new hpUser();
      that.hpUser = await hpUserObj.getUsers();
      that.hpUser = _.orderBy(that.hpUser, "firstName", "asc");
      that.hpUser.forEach(function (user) {
        that.staff.push({
          text: user.firstName + " " + user.lastName,
          value: user.username,
        });
      });
    },
    navigateFrontPage: function () {
      this.$router.push({ path: "/" });
    },
    getAssets(assetId) {
      const query = `query GetEquipmentLogAsset($id: ID!) {
            getEquipmentLogAsset (id: $id){
                id
                product
                category
                hpReference
                model
                serial
                purchaseDate
                cost
                password
                supplierLink
                maintenance
                deliverTo
                createdAt
                isDeleted
                equipmentLogService {
                    items {
                        id
                        date
                        maintainedBy
                        maintainedByEmail
                        result
                        calibrate
                        other
                        service
                        note
                    }
                }
                equipmentLogHistory {
                    items {
                        id
                        date
                        createdBy
                        createdByEmail
                        history
                    }
                }
            }
        }`;

      API.graphql(graphqlOperation(query, { id: assetId })).then((result) => {
        this.asset = result.data.getEquipmentLogAsset;

        this.assetForm = {
          id: this.asset.id,
          description: this.asset.category,
          reference: this.asset.hpReference,
          serial: this.asset.serial,
          model: this.asset.model,
          cost: this.asset.cost,
          password: this.asset.password,
          supplierLink: this.asset.supplierLink,
          maintenance: this.asset.maintenance,
        };
        this.calibration = this.asset.equipmentLogService.items;
        this.history = this.asset.equipmentLogHistory.items;
      });
    },
    onCreateAsset: function () {
      if (this.$refs.form.validate()) {
        const query = `mutation UpdateEquipmentLogAsset(
                    $id: ID!
                    $category: String!
                    $hpReference: String!
                    $model: String!
                    $serial: String!
                    $cost: String!
                    $password: String
                    $maintenance: String
                    $supplierLink: String
                    ) {
                    updateEquipmentLogAsset(input: {
                        id: $id,
                        category: $category,
                        hpReference: $hpReference,
                        model: $model,
                        serial: $serial,
                        cost: $cost,
                        password: $password,
                        maintenance: $maintenance,
                        supplierLink: $supplierLink,
                    }){
                        id,
                        product,
                        category,
                        hpReference,
                        model,
                        serial,
                        cost,
                        password,
                        maintenance,
                        supplierLink
                    }
                }`;

        API.graphql(
          graphqlOperation(query, {
            id: this.asset.id,
            category: this.assetForm.description,
            hpReference: this.assetForm.reference,
            model: this.assetForm.model,
            serial: this.assetForm.serial,
            cost: this.assetForm.cost,
            password: this.assetForm.password,
            maintenance: this.assetForm.maintenance,
            supplierLink: this.assetForm.supplierLink
              ? this.assetForm.supplierLink
              : null,
          })
        ).then((result) => {
          let asset = result.data.updateEquipmentLogAsset;
          this.assetForm = {
            id: asset.id,
            description: asset.category,
            reference: asset.hpReference,
            serial: asset.serial,
            model: asset.model,
            cost: asset.cost,
            password: asset.password,
            maintenance: asset.maintenance,
            supplierLink: asset.supplierLink,
          };
        });
      }
      this.message.snackbarText = "Asset updated";
      this.message.snackbar = true;
    },
    onCopyAsset: function () {
      const query = `query GetEquipmentLogAsset($id: ID!) {
                getEquipmentLogAsset (id: $id){
                    id
                    product
                    category
                    hpReference
                    model
                    serial
                    purchaseDate
                    cost
                    password
                    maintenance
                    deliverTo
                    createdAt
                    isDeleted
                }
            }`;

      API.graphql(graphqlOperation(query, { id: this.$route.params.id })).then(
        (result) => {
          let asset = result.data.getEquipmentLogAsset;

          const query = `mutation CreateEquipmentLogAsset (
                    $product: String!
                    $category: String!
                    $hpReference: String!
                    $model: String!
                    $serial: String!
                    $purchaseDate: String!
                    $cost: String!
                    $maintenance: String
                    $createdAt: String!
                    $isDeleted: Int!
                    ) {
                    createEquipmentLogAsset(input: {
                        product: $product,
                        category: $category,
                        hpReference: $hpReference,
                        model: $model,
                        serial: $serial,
                        purchaseDate: $purchaseDate,
                        cost: $cost,
                        maintenance: $maintenance,
                        createdAt: $createdAt,
                        isDeleted: $isDeleted,
                        equipmentLogAssetEquipmentLogBundleId:"702fd409-7c13-456d-97ce-c72da624d3d2",
                    }){
                        id,
                        product,
                        category,
                        hpReference,
                        model,
                        serial,
                        purchaseDate,
                        cost,
                        maintenance,
                        password,
                        createdAt,
                        isDeleted
                    }
                }`;

          API.graphql(
            graphqlOperation(query, {
              product: asset.product,
              category: asset.category,
              hpReference: "Ref",
              model: asset.model,
              serial: "Serial",
              purchaseDate: new Date().toISOString(),
              cost: asset.cost,
              createdAt: new Date().toISOString(),
              isDeleted: 0,
            })
          ).then((result) => {
            let asset = result.data.createEquipmentLogAsset;
            this.onCreateHistory("New Asset Created", asset.id);
            this.$router.push({ name: "asset", params: { id: asset.id } });
            this.message.snackbarText = "Asset copied";
            this.message.snackbar = true;
            this.$router.go();
          });
        }
      );
    },
    onDeleteAsset: function () {
      if (this.$refs.form.validate()) {
        const query = `mutation UpdateEquipmentLogAsset(
                    $id: ID!
                    $isDeleted: Int!
                    $deleteReason: String!
                    ) {
                    updateEquipmentLogAsset(input: {
                        id: $id,
                        isDeleted: $isDeleted,
                        deleteReason: $deleteReason
                    }){
                        id,
                        product,
                        category,
                        hpReference,
                        model,
                        serial,
                        cost,
                        password,
                        isDeleted
                    }
                }`;

        API.graphql(
          graphqlOperation(query, {
            id: this.asset.id,
            isDeleted: 1,
            deleteReason: this.deleteReason,
          })
        ).then((result) => {
          let asset = result.data.updateEquipmentLogAsset;
          this.$router.push({ name: "home" });
        });
      }
    },
    onCreateMaintenanceTask: function () {
      const query = `mutation CreateEquipmentLogService (
                $equipmentLogServiceEquipmentLogAssetId: ID!
                $date: String!
                $maintainedBy: String!
                $maintainedByEmail: String!
                $calibrate: Boolean
                $service: Boolean
                $other: Boolean
                $result: String
                $note: String
            ) {
                createEquipmentLogService(input: {
                    equipmentLogServiceEquipmentLogAssetId: $equipmentLogServiceEquipmentLogAssetId
                    date: $date
                    maintainedBy: $maintainedBy
                    maintainedByEmail: $maintainedByEmail
                    calibrate: $calibrate
                    service: $service
                    other: $other
                    result: $result
                    note: $note
                }){
                    date
                    maintainedBy
                    maintainedByEmail
                    result
                    calibrate
                    service
                    other
                    note
                }
            }`;

      let user = this.staff.filter(
        user => user.value === this.maintenanceForm.staff
      );

      API.graphql(
        graphqlOperation(query, {
          equipmentLogServiceEquipmentLogAssetId: this.$route.params.id,
          date: new Date(this.maintenanceForm.date),
          maintainedBy: user[0].text,
          maintainedByEmail: this.maintenanceForm.staff,
          calibrate: this.maintenanceForm.type === "calibrate" ? true : false,
          service: this.maintenanceForm.type === "service" ? true : false,
          other: this.maintenanceForm.type === "other" ? true : false,
          result: this.maintenanceForm.result,
          note: this.maintenanceForm.note ? this.maintenanceForm.note : null,
        })
      ).then(result => {
        let task = result.data.createEquipmentLogService;
        this.calibration.push(task);
      });

      this.message.snackbarText = "Maintenance task added";
      this.message.snackbar = true;
      this.maintenanceDialog = false;
    },
    onCreateHistory: function (history, assetId) {
      const query = `mutation CreateEquipmentLogHistory(
                    $date: String! 
                    $createdBy: String!
                    $createdByEmail: String!
                    $history: String!
                    $equipmentLogHistoryEquipmentLogAssetId: ID!
                ) {
                createEquipmentLogHistory (input: {
                    date: $date
                    createdBy: $createdBy
                    createdByEmail: $createdByEmail
                    history: $history
                    equipmentLogHistoryEquipmentLogAssetId: $equipmentLogHistoryEquipmentLogAssetId
                }){
                    id,
                    date
                    createdBy
                    createdByEmail
                    history
                }
            }`;

      Auth.currentAuthenticatedUser().then((user) => {
        let staff = this.staff.filter(
          staff => staff.value === user.attributes.email
        );

        API.graphql(
          graphqlOperation(query, {
            date: new Date().toISOString(),
            createdBy: staff[0].text,
            createdByEmail: staff[0].value,
            history: history,
            equipmentLogHistoryEquipmentLogAssetId: assetId,
          })
        );
      });
    },
    filterCurrency() {
      if (!isNaN(this.assetForm.cost)) {
        this.assetForm.cost = parseFloat(this.assetForm.cost).toFixed(2);
      }
    },
    getAvatarUrl(username) {
      const staff = this.hpUser.filter((user) => user.username === username);
      if (staff.length === 0) {
        return false;
      }
      return staff[0].s3avatarUrl;
    }
  }
};
</script>
<style>
.v-btn--back {
  bottom: -15px;
  margin: 0 0 16px 0px;
}
.v-tabs-slider {
  background-color: #6fac46;
}
</style>
